<app-navbar [showSignOut]="showSignOut"
            (logout)="handleLogout()"
            (login)="handleLogin()">
</app-navbar>
<!-- Main Content -->
<!--<div class="container-fluid px-3 px-md-4 py-4">-->
<div class="container-xxl px-2 px-md-4 px-lg-5 py-2 py-md-4">
  <router-outlet></router-outlet>
</div>
<c11n-modal-dialog-entrypoint></c11n-modal-dialog-entrypoint>
